<template>
  <div class="item row shadow-sm" :data-bol="item.billOfLading">
    <div class="col-3 m-auto">{{ item.billOfLading }}</div>
    <div
      class="col m-auto"
      :title="item.shipper"
      style="white-space: nowrap; overflow-y: hidden; text-overflow: ellipsis;"
    >{{ item.shipper }}</div>
    <div
      class="col m-auto"
      :title="item.consignee"
      style="white-space: nowrap; overflow-y: hidden; text-overflow: ellipsis;"
    >{{ item.consignee }}</div>
    <div
      class="col m-auto"
      :title="item.airportCode"
      style="white-space: nowrap; overflow-y: hidden; text-overflow: ellipsis;"
    >{{ item.airportCode }}</div>
    <div
      class="col m-auto"
      style="white-space: nowrap; overflow-y: hidden; text-overflow: ellipsis;"
    >{{ statusType(this.item.status) }}
  </div>
</div>
</template>

<script>
export default {
  name: 'ContainerWidgetItem',
  props: ['item'],
  data() {
    return {
      statusTypes: [
        { value: 'toload', text: 'to load' },
        { value: 'tooffload', text: 'to offload' },
        { value: 'todeliver', text: 'loaded' },
        { value: 'completed', text: 'delivered' },
      ],
    };
  },
  methods: {
    statusType(value) {
      const type = this.statusTypes.find((status) => status.value === value);
      if (type) {
        return type.text;
      }
      return '';
    },
  },
};
</script>

<style scoped>
.col {
  overflow-x: hidden;
}
</style>
